import React from "react";
import moment from "moment";
import { formatDate } from "components/QueryBuilder/Utils/QueryBuilderUtils";

const QueryBuilderXAxis = (props) => {
  const { x, y, payload, granularity } = props;

  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={15}
        textAnchor="middle"
        style={{ fontSize: 12 }}
        fill="#979797"
      >
        {moment(new Date(payload.value))
          .utc()
          .format(formatDate(granularity.value))}
      </text>
    </g>
  );
};

export default QueryBuilderXAxis;
